import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import classNames from 'classnames/bind'
import { useSelector } from 'react-redux'
import { Icon, InputLabel, TextField, Autocomplete, Hint, SvgIcon } from 'components'
import { ReactComponent as ExternalLinkIcon } from 'static/ic_external_link.svg'
import { colors } from '../../constants'

const useStyles = makeStyles({
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    position: 'relative',
  },
  column: {
    width: '47%',
  },
  input: {
    width: '100%',
    marginBottom: 4,
  },
  deleteIcon: {
    position: 'absolute',
    right: '-30px',
    top: 30,
    fontSize: 23,
    cursor: 'pointer',
    color: '#575757',
    opacity: 0.7,
    '&:hover': {
      opacity: 1,
    },
  },
  hint: {
    color: colors.ERROR,
    padding: '5px 0',
    textAlign: 'left',
  },
  icon: {
    marginRight: 8,
  },
  inputError: {
    borderColor: colors.ERROR,
  },
  adminLink: {
    marginLeft: 10,
    fontSize: 20,
    color: colors.BASIC.COLOR[80],
  },
  label: {
    display: 'flex',
  },
  notchedOutline: {
    borderColor: colors.BASIC.COLOR[50],
    '&$focused': {
      borderColor: colors.BASIC.COLOR[80],
    },
  },
  error: {
    borderColor: colors.ERROR,
  },
  externalLinkIcon: {
    width: 16,
    height: 16,
    marginBottom: 1,
  },
  bar: {
    marginRight: 8,
    lineHeight: '1.3',
  },
})

const LicensingRow = props => {
  const {
    state,
    states,
    provinces,
    barId,
    verificationLink,
    errors = {},
    onLicenseChange,
    onLicenseDelete,
    rowClass,
    id,
    isDisabled,
    isAdminLinkShown,
  } = props
  const classes = useStyles()

  // Get current user to check if they are an accountant
  const currentUser = useSelector(state => state.auth.currentUser)
  const isAccountant = currentUser?.subrole === 'accountant'

  // Get the contact info to determine which country is selected
  const contactInfo = useSelector(state => state.profileCreation.profileData.contactInfo)
  console.log(contactInfo)
  const selectedCountry = contactInfo?.country

  // Determine which options to show based on country selection
  const getLocationOptions = () => {
    if (!isAccountant) return states

    if (selectedCountry === 124) {
      // Canada
      return provinces || []
    } else {
      // USA (default)
      return states || []
    }
  }

  const getLocationLabel = () => {
    if (!isAccountant) return 'Issuing State'
    else return 'Issuing State / Province'
  }

  const getLicenseLabel = () => {
    if (!isAccountant) return 'Bar/License number'
    else return 'License number'
  }

  const VerificationLink = () => (
    <a href={verificationLink} target="_blank" rel="noopener noreferrer">
      <SvgIcon component={ExternalLinkIcon} viewBox="0 0 16 16" className={classes.externalLinkIcon} />
    </a>
  )

  return (
    <div
      className={classNames({
        [classes.row]: true,
        [rowClass]: true,
      })}
    >
      <div className={classes.column}>
        <div className={classes.label}>
          <InputLabel classes={{ root: classes.bar }}>{getLicenseLabel()}</InputLabel>
          {isAdminLinkShown && verificationLink && <VerificationLink />}
        </div>
        <TextField
          className={classes.input}
          variant="outlined"
          InputProps={{
            classes: {
              notchedOutline: !!errors.barId ? classes.inputError : null,
            },
          }}
          value={barId}
          onChange={e => onLicenseChange(id, 'barId', e.target.value)}
          disabled={isDisabled}
        />
        {errors.barId && (
          <Hint classes={{ subtitle2: classes.hint }}>
            <Icon style={classes.icon} iconClass="las la-exclamation-triangle" />
            {errors.barId}
          </Hint>
        )}
      </div>
      <div className={classes.column}>
        <InputLabel>{getLocationLabel()}</InputLabel>
        <Autocomplete
          className={classes.input}
          variant="outlined"
          value={state}
          onChange={(e, value) => onLicenseChange(id, 'state', value ? value.value : '')}
          filterOptions={(options, { inputValue }) =>
            getLocationOptions().filter(option => option.label.toLowerCase().startsWith(inputValue.toLowerCase()))
          }
          options={getLocationOptions()}
          fullWidth
          disabled={isDisabled}
          InputProps={{
            classes: {
              notchedOutline: errors.state ? classes.error : classes.notchedOutline,
            },
          }}
        />
        {errors.state && (
          <Hint classes={{ subtitle2: classes.hint }}>
            <Icon style={classes.icon} iconClass="las la-exclamation-triangle" />
            {errors.state}
          </Hint>
        )}
      </div>
      {!isDisabled && (
        <Icon onClick={() => onLicenseDelete(id)} style={classes.deleteIcon} iconClass="las la-trash-alt" />
      )}
    </div>
  )
}

export default LicensingRow
